import React from 'react'

import { Menu, Image, Popup } from 'semantic-ui-react'

const MenuItem = ({ name, icon, isActive, isSmallSideBar, onClick }: IProps) => {
  const menuItemColor = isActive ? 'violet' : 'blue'
  
  return isSmallSideBar ? (
    <Popup
      position="right center"
      content={name}
      trigger={
        <Menu.Item as="a" active={isActive} onClick={onClick} color={menuItemColor}>
          <Image width="25px" src={icon as string} wrapped />
        </Menu.Item>
      }
    />
  ) : (
    <Menu.Item as="a" active={isActive} onClick={onClick} color={menuItemColor}>
      <Image width="25px" src={icon as string} wrapped /> <span style={{ marginLeft: '2rem' }}>{name}</span>
    </Menu.Item>
  )
}

interface IProps {
  name: string
  icon: string
  isActive: boolean
  isSmallSideBar: boolean
  onClick: () => void
}

export default MenuItem
